import React from 'react';
import { Box } from '@mui/material';
import { Controller } from 'react-hook-form';
import type { AuditDynamicFormSoldCalculationProps } from '../../types/auditFormTypes';
import { calculateTicketsSoldFromRangeResult } from '../../features/audit/fixOcr/utils/ticketBalanceCalculations';

const AuditDynamicFormSoldCalculation: React.FC<AuditDynamicFormSoldCalculationProps> = React.memo(({
  idx,
  control,
  ticket,
}) => {
  return (
    <Controller
      name={`ticket_details.${idx}.range`}
      control={control}
      render={({ field }) => {
        const result = calculateTicketsSoldFromRangeResult(field.value, ticket?.ticketsPerPack);
        const sold = result.isValid ? String(result.sold) : '';

        return (
          <Box
            sx={{
              minWidth: 40,
              width: 40,
              maxWidth: 40,
              textAlign: 'right',
              fontWeight: 500,
              fontSize: 15,
              color: '#222B45',
              px: 1,
              height: '17px',
              maxHeight: '17px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            {sold}
          </Box>
        );
      }}
    />
  );
});

AuditDynamicFormSoldCalculation.displayName = 'AuditDynamicFormSoldCalculation';

export default AuditDynamicFormSoldCalculation;
